import '../App.css';

import {
  useEffect,
  useState,
  useRef
} from 'react';
import { useSearchParams } from 'react-router-dom';

import axios from 'axios';
import {
  ethers
} from 'ethers';


import {
  useAddress,
  ConnectWallet
} from "@thirdweb-dev/react";

function App() {

  const [addr, setaddr] = useState('')


  const address = useAddress();

  useEffect(() => {
    if (address) {
      setaddr(address);
      checkBalance(address);
    }
  }, [address]);


  const previousAddressRef = useRef();
  useEffect(() => {
    previousAddressRef.current = address;
  }, [address]);
  const previousAddress = previousAddressRef.current;

  useEffect(() => {
    if (previousAddress && !address) {
      document.getElementById("myapes").classList.add("disabled-button");
      window.location.reload();
    }
  }, [address, previousAddress]);

  const contract = {
    address: "0x7CB90567a118cd9F6CA326067A0813b289bdCb54",
    abi: [
      "function balanceOf(address account) external view returns (uint256)",
      "function ownerOf(uint256 tokenId) public view override returns (address)",
      "function tokenOfOwnerByIndex(address owner, uint256 index) external view returns (uint256 tokenId)"
    ]
  };

  async function checkBalance(address) {

    const RPC = "https://eth-mainnet.g.alchemy.com/v2/IMNqSrlujceCbwZctSKT5RdsADgL5nzj";
    const provider = new ethers.providers.JsonRpcProvider(RPC);

    const CONTRACT_ADDRESS = new ethers.Contract(contract.address, contract.abi, provider);

    var bal = await CONTRACT_ADDRESS.balanceOf(address);

    document.getElementById("myapes").innerHTML = "My Genesis (" + bal + ")";

    if (bal > 0) {
      document.getElementById("myapes").classList.remove("disabled-button");
    }
  }

  const [searchParams] = useSearchParams();
  const rotaToken = useState(searchParams.get("token"));

  const rarityOrder = [3083, 3118, 2223, 3623, 3967, 3006, 598, 1806, 1471, 158, 2768, 2210, 3709, 2205, 491, 402, 785, 4130, 2282, 2872, 1379, 4012, 4008, 884, 1321, 1197, 72, 2612, 1969, 2222, 3196, 980, 2361, 2340, 3802, 2659, 2048, 1505, 4004, 1175, 3446, 3636, 110, 4436, 1786, 2344, 2535, 1346, 2443, 353, 3892, 4284, 829, 298, 3258, 1761, 1457, 4057, 1128, 3229, 199, 1144, 1898, 174, 1643, 1310, 1172, 831, 876, 1058, 89, 2339, 2321, 593, 3212, 2539, 3604, 1726, 4069, 3267, 2164, 2474, 2827, 1136, 3866, 3725, 2332, 1650, 622, 1273, 2649, 3632, 1667, 2897, 2023, 3295, 3337, 2932, 2018, 4346, 3250, 1000, 4027, 1234, 2865, 1133, 2318, 3110, 3898, 1516, 3752, 1513, 74, 3405, 3377, 788, 4276, 3597, 147, 2446, 3537, 4086, 1062, 3260, 2211, 2000, 189, 3679, 2264, 2328, 3236, 1889, 1487, 272, 55, 1098, 1357, 2316, 1190, 682, 691, 413, 1787, 1491, 1083, 1483, 2510, 3421, 1092, 1735, 2711, 1824, 3908, 3944, 1649, 3451, 1948, 3319, 899, 2663, 3521, 1198, 2595, 383, 1264, 2776, 1024, 1521, 636, 1879, 2905, 764, 3527, 2127, 78, 3392, 4275, 567, 2359, 1019, 3808, 3312, 1988, 2750, 3928, 1160, 120, 2491, 3270, 1096, 847, 1139, 3391, 3688, 2294, 1657, 2552, 1120, 365, 1811, 431, 4209, 3834, 1068, 2846, 1779, 868, 1034, 2814, 1134, 4026, 4222, 965, 3420, 275, 459, 3992, 61, 3471, 2183, 1854, 1965, 3130, 3995, 3092, 3305, 3016, 2914, 2194, 4067, 2870, 50, 3025, 1279, 729, 2118, 2660, 2671, 701, 581, 447, 4435, 3384, 4384, 3190, 2796, 2741, 1079, 4129, 3437, 73, 2423, 164, 3854, 1237, 2527, 3000, 3686, 2997, 1992, 3442, 1208, 3354, 4099, 773, 3246, 1344, 712, 1444, 3273, 2414, 958, 123, 3398, 1606, 306, 428, 1042, 1638, 1668, 4253, 2737, 4257, 1975, 2731, 2822, 371, 1474, 1717, 1489, 303, 845, 1926, 702, 4353, 4317, 2338, 3833, 1011, 1114, 274, 2438, 2790, 3667, 350, 176, 2576, 1946, 2456, 3786, 713, 2433, 1887, 1404, 2287, 3861, 1856, 1152, 677, 1655, 3461, 3361, 3490, 507, 2179, 4362, 1673, 3663, 1446, 2629, 774, 253, 534, 1885, 3414, 1089, 1790, 1582, 4335, 1257, 3594, 1616, 694, 4163, 2670, 3549, 3286, 2119, 1674, 4443, 4143, 4296, 1, 792, 1593, 2173, 1057, 762, 2751, 3785, 2045, 2824, 709, 1094, 797, 610, 2743, 3240, 3650, 4226, 2584, 3998, 1345, 2513, 1566, 3046, 3132, 1919, 4376, 3844, 2518, 4193, 2823, 2521, 1939, 4278, 2002, 1532, 620, 3692, 3248, 2037, 407, 1652, 3818, 2755, 2090, 3216, 2008, 443, 1216, 3241, 692, 3390, 3146, 4147, 157, 3284, 1296, 1086, 1486, 2415, 1666, 1757, 4236, 4028, 1819, 1470, 2149, 244, 3264, 1443, 759, 262, 2732, 3200, 3416, 1394, 456, 2873, 1698, 2715, 1557, 3425, 4016, 1884, 3170, 433, 1254, 4072, 3482, 3050, 3648, 2656, 4378, 1843, 4246, 1436, 3610, 426, 1246, 214, 3556, 3218, 2458, 3502, 1720, 4212, 1656, 1875, 2112, 1732, 3885, 1857, 3727, 119, 1504, 1713, 2430, 1950, 4215, 2607, 2216, 3098, 454, 2662, 2480, 867, 3897, 3680, 1166, 1320, 1874, 2420, 1684, 744, 1503, 1007, 1604, 4058, 908, 1620, 2560, 4074, 2265, 1723, 1432, 849, 820, 807, 2867, 3572, 128, 360, 1583, 1123, 4356, 984, 4327, 1363, 2648, 254, 3625, 3821, 2145, 3535, 2742, 2903, 278, 1385, 2181, 3669, 4393, 540, 232, 4297, 1370, 1384, 4307, 3523, 1014, 1419, 2088, 3608, 4318, 2485, 2627, 4160, 889, 4396, 2635, 1692, 3593, 4441, 841, 3561, 2035, 3777, 2165, 3882, 3280, 839, 1222, 2845, 238, 2680, 3867, 2507, 363, 1537, 1262, 3498, 2270, 2109, 404, 1164, 367, 751, 3797, 1833, 3053, 2487, 1578, 2638, 2208, 2132, 1291, 3159, 684, 3784, 3624, 3905, 3896, 2104, 1676, 455, 1247, 1614, 3507, 4316, 3718, 3552, 4202, 3696, 2581, 3814, 70, 374, 16, 3958, 1694, 3276, 4039, 1838, 2469, 1550, 3767, 871, 108, 20, 1207, 2808, 2761, 584, 2927, 57, 69, 2634, 1800, 1685, 2059, 3519, 662, 2858, 3742, 3428, 449, 513, 3466, 2590, 2574, 345, 779, 3028, 2235, 4315, 3660, 3906, 2674, 570, 2777, 4391, 4150, 1734, 2502, 502, 3030, 1690, 1076, 3035, 4260, 4108, 2448, 1958, 3411, 4121, 3062, 3378, 4426, 4078, 2465, 3753, 3789, 136, 46, 2608, 2654, 410, 2091, 1982, 2871, 1871, 251, 2615, 154, 3303, 1462, 3058, 1009, 3439, 1288, 3317, 564, 3735, 1338, 3838, 2682, 1899, 1030, 3853, 780, 4336, 1579, 1064, 2971, 3287, 2040, 111, 3375, 1580, 1683, 2572, 3639, 1287, 3185, 2178, 2449, 4189, 4401, 4351, 2072, 1881, 1500, 3857, 2404, 3262, 1395, 3156, 3612, 2678, 226, 1276, 3067, 1352, 304, 2941, 1192, 1640, 3988, 341, 4090, 635, 1035, 4320, 4081, 4334, 1400, 2501, 966, 2139, 3736, 1411, 1770, 2847, 2745, 2820, 3712, 4182, 3732, 3458, 398, 3474, 2929, 142, 4265, 1841, 3051, 2881, 3895, 956, 4397, 3671, 1130, 3614, 1147, 3595, 3184, 3940, 3501, 4375, 946, 766, 442, 4432, 4021, 2618, 4056, 269, 3181, 1917, 1218, 4372, 919, 2701, 3512, 3205, 2006, 2039, 2114, 2909, 1756, 3772, 3206, 2473, 670, 1381, 921, 4332, 826, 688, 1041, 1117, 2499, 738, 2568, 3514, 2297, 210, 3996, 2432, 2924, 3687, 40, 1862, 1533, 229, 490, 425, 2497, 3800, 3436, 4162, 1639, 1836, 203, 3722, 252, 2454, 3573, 2965, 3272, 49, 2962, 2064, 3315, 3408, 3177, 197, 539, 1512, 4306, 1328, 2280, 411, 2343, 811, 3526, 505, 3654, 2538, 393, 1416, 3065, 127, 18, 1867, 549, 1490, 1188, 2055, 836, 2505, 4094, 4158, 1759, 3245, 3102, 4308, 1424, 113, 1747, 3069, 3497, 2315, 3927, 4030, 2904, 1968, 736, 2517, 2252, 705, 1749, 2878, 3577, 3548, 1508, 283, 2122, 4280, 3706, 699, 586, 4034, 2960, 1558, 988, 518, 2825, 4183, 3299, 1327, 3750, 1928, 2537, 4141, 2609, 4188, 1542, 1809, 2271, 3155, 602, 1304, 1729, 922, 2341, 1921, 1688, 731, 2267, 2798, 637, 4060, 2240, 4239, 591, 1293, 3894, 1773, 3274, 1914, 1840, 80, 3011, 2829, 2795, 3830, 422, 3456, 2177, 4430, 2833, 4254, 2582, 1748, 2190, 3298, 1217, 2333, 233, 3413, 2947, 36, 1434, 14, 651, 160, 590, 1437, 1312, 1903, 2378, 3165, 953, 2293, 596, 3558, 659, 895, 3910, 351, 1646, 1991, 972, 357, 1607, 3596, 3720, 4369, 4161, 1696, 3912, 3108, 3742, 3085, 1647, 4059, 186, 1360, 3661, 2495, 1567, 4207, 349, 2041, 2452, 4245, 2169, 3878, 401, 1615, 808, 1055, 150, 1045, 2426, 4005, 4406, 819, 139, 3452, 3565, 2182, 2755, 3014, 2614, 3017, 936, 3617, 98, 1804, 3449, 2259, 3822, 4329, 2123, 4365, 497, 1554, 1392, 2707, 1343, 3592, 1158, 917, 300, 800, 4164, 3093, 975, 775, 2556, 3202, 2792, 116, 2716, 441, 4415, 1067, 4291, 3580, 1015, 1823, 1380, 384, 204, 194, 4414, 3941, 3163, 2389, 27, 2653, 3186, 976, 1252, 2573, 1269, 2244, 1047, 3677, 112, 3598, 4084, 3911, 2407, 824, 178, 517, 2281, 2944, 3321, 3516, 1920, 2888, 2392, 4089, 3148, 1872, 2466, 531, 2434, 2558, 2441, 1329, 2201, 3239, 2717, 893, 2440, 2770, 247, 1255, 2775, 2639, 3393, 986, 1278, 3783, 4122, 781, 4165, 2637, 3807, 952, 3952, 2025, 955, 2290, 3106, 4031, 3819, 565, 2939, 992, 1493, 405, 3907, 1999, 1915, 2324, 3247, 1401, 3628, 665, 1636, 1220, 2860, 400, 1737, 93, 1507, 3775, 126, 1585, 2428, 949, 3701, 3252, 3036, 4192, 628, 846, 163, 3874, 342, 4243, 3618, 2762, 1409, 2481, 2383, 3464, 2664, 959, 53, 2043, 1494, 1478, 2650, 2583, 3469, 1145, 1016, 1193, 4025, 2096, 187, 1051, 2850, 2288, 2657, 2551, 574, 1355, 1935, 611, 1033, 1828, 65, 1017, 2156, 3751, 1609, 3978, 600, 2371, 2200, 1782, 3931, 2198, 2277, 220, 3131, 1907, 3491, 1109, 848, 3943, 872, 722, 3041, 4185, 882, 3368, 3655, 2326, 2899, 41, 2437, 3331, 3965, 4314, 1348, 231, 2196, 458, 2698, 1, 292, 650, 4159, 1959, 1224, 1005, 319, 249, 3322, 3747, 3040, 3569, 3412, 2781, 1272, 409, 3520, 888, 4370, 1703, 1568, 4343, 2831, 608, 1389, 3762, 1555, 3731, 655, 2976, 1001, 2417, 1518, 2442, 103, 1538, 3887, 3385, 1473, 777, 496, 2977, 4009, 2884, 3367, 2922, 3100, 880, 3084, 2597, 3629, 328, 362, 3506, 3379, 3835, 765, 2801, 835, 2818, 1087, 391, 2529, 4281, 3733, 4418, 453, 1488, 1630, 71, 734, 2289, 2347, 1586, 1213, 2832, 3797, 4323, 2283, 83, 852, 3603, 961, 3570, 2953, 4151, 2786, 3330, 1629, 810, 3746, 963, 3141, 2990, 1792, 1575, 3152, 3847, 4269, 450, 560, 3371, 3779, 3576, 2819, 218, 1631, 3283, 1229, 2335, 2848, 3342, 30, 1878, 3338, 3288, 3842, 1531, 2646, 334, 3294, 3314, 3438, 3417, 3189, 2780, 2082, 2450, 107, 3976, 770, 638, 776, 1626, 2278, 4178, 4169, 2429, 172, 240, 2436, 1241, 122, 4003, 823, 1178, 1102, 3063, 554, 2074, 499, 742, 2934, 2403, 2599, 1741, 434, 1785, 2687, 1169, 1708, 4138, 1662, 2062, 3505, 2102, 3980, 4348, 672, 3341, 446, 2003, 3255, 3301, 3013, 3486, 4442, 2940, 3935, 1775, 498, 528, 1181, 3094, 1406, 3003, 3738, 2859, 4338, 733, 902, 4326, 1709, 3221, 1226, 2876, 1036, 3228, 1171, 2880, 3769, 3963, 1763, 3162, 3860, 185, 1440, 1971, 4098, 2197, 3369, 2759, 2213, 3684, 2244, 2254, 2250, 4020, 3781, 2133, 3757, 2005, 43, 2902, 3676, 1810, 1187, 748, 1682, 372, 1962, 2893, 2869, 2805, 652, 3259, 3640, 1366, 4340, 912, 23, 575, 2009, 3559, 545, 3121, 1951, 3204, 421, 1858, 3015, 4105, 970, 3513, 3242, 419, 1100, 2643, 3472, 1223, 3227, 141, 1475, 678, 257, 4201, 1115, 1814, 326, 4234, 2575, 1765, 763, 1581, 547, 202, 2577, 2362, 3574, 2232, 171, 3803, 4440, 320, 994, 230, 3150, 3026, 3174, 4145, 3366, 2158, 3700, 3579, 858, 2901, 2603, 3531, 3500, 2725, 3082, 2300, 4149, 2826, 2291, 2895, 4251, 1129, 2984, 3715, 190, 3745, 2727, 3540, 2547, 529, 2531, 3848, 1177, 3813, 1832, 86, 3029, 3263, 3972, 99, 3670, 3615, 2557, 4409, 4256, 3143, 165, 2545, 1071, 2601, 3873, 1460, 100, 2665, 1472, 1155, 3460, 389, 648, 129, 1546, 1154, 1448, 2390, 54, 2625, 1642, 3758, 1660, 418, 2124, 1587, 3404, 799, 1148, 2964, 689, 1101, 483, 3462, 721, 821, 3057, 2385, 4206, 750, 1170, 1755, 3424, 2811, 4242, 1458, 4109, 4263, 1270, 3485, 2694, 1485, 506, 616, 3080, 1231, 3809, 1233, 3400, 544, 1964, 2306, 3716, 4422, 1807, 4191, 1347, 3192, 3160, 168, 3793, 2004, 4172, 4140, 1700, 806, 3481, 592, 707, 381, 3309, 1706, 1826, 1839, 951, 1612, 1426, 2892, 4064, 3300, 2921, 133, 969, 623, 19, 3061, 4195, 2427, 2967, 323, 3450, 886, 1522, 399, 3376, 562, 1892, 32, 4092, 2783, 1795, 3875, 2493, 1528, 1525, 2348, 3142, 1397, 2310, 1549, 2619, 558, 2875, 2435, 1453, 1247, 1998, 2707, 3708, 1073, 758, 2080, 2632, 4120, 4288, 2275, 660, 2365, 2272, 1238, 290, 1923, 3734, 2305, 476, 4239, 481, 556, 3470, 241, 468, 4266, 1985, 4131, 3101, 2304, 4071, 2642, 3068, 2117, 2219, 2224, 1340, 2500, 842, 2758, 4065, 3883, 2253, 148, 891, 493, 828, 2684, 1540, 1594, 1675, 4322, 1430, 1084, 1003, 4095, 786, 1983, 4238, 1004, 1290, 1842, 859, 3508, 2011, 4167, 881, 1996, 1918, 3116, 4197, 1742, 509, 2097, 3662, 1563, 851, 2677, 3694, 1793, 1560, 1368, 3711, 3479, 4341, 1382, 2051, 2353, 681, 4062, 1876, 1699, 2313, 624, 3349, 4114, 2488, 2705, 918, 1681, 2906, 2688, 67, 1299, 379, 4045, 732, 923, 2330, 3810, 1282, 3977, 3211, 151, 4173, 2969, 2110, 2693, 4092, 2861, 4076, 2712, 621, 3430, 4146, 745, 33, 840, 1845, 726, 1285, 2069, 52, 2726, 815, 4428, 3281, 3713, 4210, 2269, 3876, 1584, 3555, 1433, 2994, 1738, 3044, 756, 4354, 1455, 1445, 3176, 2255, 4387, 3532, 287, 2772, 3616, 3064, 1182, 3856, 4279, 461, 4367, 2063, 3188, 3089, 1, 3422, 2029, 752, 676, 3881, 22, 4439, 2401, 3129, 700, 2813, 1623, 3374, 934, 3316, 3649, 3066, 2056, 697, 1730, 1702, 1645, 1769, 1497, 417, 3115, 3402, 1496, 3764, 1452, 582, 2957, 2937, 1413, 3419, 1524, 3483, 2991, 280, 3282, 3122, 125, 4425, 3657, 3681, 3509, 2972, 3705, 1619, 3203, 414, 348, 1330, 1025, 2702, 1736, 3817, 392, 1573, 2374, 480, 1359, 1635, 2445, 3304, 3455, 1335, 2959, 205, 3005, 533, 2633, 1712, 1778, 2258, 1562, 2606, 2706, 3889, 2136, 2112, 3302, 2053, 2690, 159, 929, 611, 2471, 2406, 2981, 3047, 2986, 2641, 2807, 432, 1529, 3828, 3643, 525, 1499, 1995, 1228, 2320, 3168, 420, 1592, 2184, 1621, 2643, 58, 4116, 1410, 3635, 2738, 784, 1520, 2720, 1162, 1780, 1627, 1454, 3492, 4037, 2393, 3112, 59, 2620, 2421, 964, 2337, 646, 4194, 4283, 3791, 4208, 193, 1808, 2065, 3826, 88, 79, 3487, 3619, 3351, 2661, 1, 4054, 629, 2078, 3726, 3432, 2652, 4063, 4007, 1624, 1333, 4261, 2785, 761, 284, 4347, 2444, 1495, 2327, 3468, 3484, 1258, 1396, 2704, 2455, 1227, 2769, 2763, 3840, 2418, 2484, 3776, 1766, 1351, 749, 527, 2329, 463, 2864, 4142, 3770, 4148, 3719, 3919, 3529, 3724, 2203, 2541, 2713, 366, 1427, 1, 3447, 3917, 4249, 4018, 4223, 3363, 2913, 4048, 983, 4042, 812, 4437, 4227, 4408, 2773, 331, 2669, 989, 3637, 1367, 563, 2567, 981, 771, 2719, 1002, 4258, 3147, 445, 1855, 2907, 1209, 2658, 3199, 325, 2486, 2855, 3685, 1797, 973, 2989, 1070, 1551, 35, 1670, 3766, 1818, 3171, 3993, 869, 2543, 795, 2028, 2816, 3997, 3601, 3605, 4211, 184, 2199, 3427, 1598, 3973, 1891, 3571, 2298, 3073, 144, 4357, 3968, 3459, 2128, 1686, 3959, 997, 4043, 1090, 2249, 1501, 3891, 206, 1137, 3914, 3673, 3843, 248, 735, 3332, 2722, 4333, 397, 3554, 1929, 3796, 412, 656, 2511, 3920, 1815, 2266, 343, 3114, 1339, 4313, 1364, 4290, 217, 3541, 3938, 175, 201, 4250, 3095, 460, 3031, 3645, 3503, 1860, 2192, 2686, 2810, 4421, 2982, 1589, 4124, 3536, 3388, 2013, 1924, 3285, 639, 356, 1308, 2746, 2782, 289, 1110, 978, 3383, 4337, 553, 614, 3403, 3113, 2157, 2431, 2312, 415, 4394, 927, 1977, 2036, 3729, 4374, 2150, 1762, 3611, 1322, 4218, 1105, 1156, 2578, 4398, 1802, 2736, 2630, 1153, 4061, 149, 3723, 4203, 942, 1608, 2373, 1183, 1715, 3707, 1315, 2516, 1261, 1776, 45, 2968, 3307, 1979, 566, 3209, 1275, 294, 2159, 1940, 2896, 1953, 1180, 1509, 3936, 832, 1791, 3518, 3539, 3243, 2791, 2424, 1259, 2085, 3097, 1393, 373, 1963, 4000, 1548, 1028, 3386, 1718, 2388, 757, 1569, 3149, 465, 1890, 3545, 2681, 1131, 2094, 4304, 4405, 4233, 1669, 472, 2215, 1289, 1949, 1704, 489, 311, 1851, 2357, 1565, 3070, 1459, 4417, 3950, 3099, 4022, 920, 2398, 1048, 239, 3395, 2699, 3622, 90, 572, 4403, 181, 4171, 1952, 3581, 1622, 3033, 2898, 947, 2303, 516, 291, 94, 703, 1201, 1931, 1827, 191, 2381, 2457, 550, 1235, 3381, 76, 3755, 3071, 901, 2397, 3090, 4255, 2046, 4311, 2941, 3120, 1265, 725, 4328, 2061, 4287, 578, 2883, 2372, 3137, 3169, 1943, 3699, 3599, 2308, 3665, 3441, 388, 4380, 1552, 3010, 2918, 264, 2915, 2598, 4399, 3855, 2476, 3060, 2839, 2233, 1994, 2879, 2314, 668, 4127, 1967, 3825, 4271, 1945, 2739, 2460, 543, 1817, 4117, 1106, 37, 2655, 1719, 3271, 330, 995, 2425, 2585, 302, 3691, 3974, 2515, 1422, 2058, 1266, 260, 3989, 1588, 883, 3237, 4262, 1, 944, 4248, 333, 3107, 3606, 2095, 1896, 783, 4294, 1465, 546, 3037, 3362, 4170, 993, 324, 1143, 2180, 1146, 2804, 2834, 4186, 3109, 3575, 3313, 2467, 2919, 1866, 286, 4157, 3514, 1707, 2463, 3266, 2571, 3024, 4373, 1040, 3582, 4232, 3668, 3135, 1353, 387, 3081, 3858, 2778, 3924, 2949, 2794, 2509, 573, 3547, 1767, 478, 3335, 279, 2366, 4319, 1830, 2071, 3008, 1519, 2395, 3890, 683, 2540, 235, 1728, 1421, 1853, 1317, 494, 3794, 1332, 1834, 438, 1944, 2492, 437, 1852, 2067, 3495, 2470, 2528, 3563, 3761, 2076, 3987, 2730, 2788, 3863, 1080, 4024, 3703, 2925, 2410, 2938, 1714, 2367, 2522, 4100, 2322, 3697, 916, 3133, 1803, 3893, 1362, 601, 3158, 2886, 2015, 1599, 535, 4136, 798, 394, 3831, 2696, 2247, 3859, 4046, 2973, 967, 1789, 3238, 878, 3799, 3748, 2812, 1271, 92, 1910, 571, 1286, 1909, 943, 3019, 2033, 2299, 1572, 3991, 85, 2999, 3091, 2147, 42, 3994, 644, 4080, 4032, 4085, 1873, 4273, 3251, 2992, 1349, 3433, 3849, 1, 114, 1354, 2342, 2983, 3197, 3542, 1116, 4410, 2806, 3454, 3279, 1502, 3674, 2138, 627, 1911, 696, 4282, 1464, 1031, 1091, 2744, 2837, 2447, 982, 3780, 724, 1232, 1046, 2239, 3832, 4298, 4198, 51, 737, 2204, 1431, 2564, 1693, 4134, 2309, 3788, 396, 3921, 818, 219, 1281, 346, 4300, 948, 551, 1336, 332, 2928, 245, 246, 1161, 3946, 2774, 664, 3103, 121, 2105, 1260, 3567, 3290, 3339, 188, 1739, 2241, 2995, 3922, 2355, 3021, 1634, 243, 2243, 1195, 950, 1369, 1072, 1989, 1701, 3698, 1319, 4274, 3291, 2579, 3591, 3039, 3127, 1934, 1511, 4383, 2451, 2936, 307, 866, 361, 430, 2151, 3164, 3347, 716, 3001, 2589, 1678, 3045, 1768, 2400, 2526, 2279, 3886, 270, 3324, 3638, 1194, 4153, 526, 3564, 2472, 1665, 3525, 1561, 3915, 2391, 3903, 3804, 3191, 508, 1124, 1020, 4177, 2793, 2787, 4413, 711, 2843, 2610, 3480, 2554, 4285, 3651, 3739, 4230, 3382, 1571, 2140, 1225, 2735, 2591, 1442, 1574, 1309, 3075, 2626, 1425, 642, 640, 2066, 3811, 1602, 2038, 656, 3664, 1295, 309, 2760, 3257, 3002, 739, 338, 667, 2384, 968, 1954, 3278, 2912, 2014, 4423, 3923, 316, 1311, 3096, 2142, 814, 2565, 2628, 1044, 63, 2570, 1449, 380, 2044, 2413, 2958, 2125, 38, 768, 1135, 2747, 1661, 3763, 2334, 3473, 2530, 3123, 97, 1075, 4225, 2640, 1138, 1774, 307, 2840, 1973, 355, 1469, 911, 2561, 3945, 156, 4339, 2189, 132, 769, 1268, 3939, 3979, 892, 1671, 3488, 1869, 1672, 258, 3180, 359, 2251, 2220, 1151, 3327, 1822, 3982, 2496, 464, 216, 1196, 213, 3880, 3934, 4055, 991, 3074, 2227, 1847, 347, 500, 403, 2187, 1901, 4144, 3119, 3297, 81, 3478, 2955, 2613, 2202, 145, 2141, 470, 3504, 822, 3042, 3325, 1904, 4324, 2797, 3048, 974, 3151, 2703, 885, 4029, 928, 4427, 2548, 1358, 1796, 843, 4321, 2311, 1377, 1049, 152, 2020, 1450, 1, 1937, 587, 3851, 1716, 2978, 2835, 3587, 1618, 1751, 3056, 2049, 2186, 4407, 2185, 1221, 1012, 914, 1211, 753, 830, 813, 1302, 3528, 3953, 3765, 4344, 904, 3086, 523, 3289, 3930, 1256, 56, 3426, 4079, 3792, 4050, 3207, 2596, 4174, 3178, 850, 3918, 941, 3396, 3328, 117, 3463, 875, 1314, 945, 1870, 3076, 277, 82, 1506, 473, 3336, 2146, 2016, 3365, 1752, 1733, 2416, 2193, 4438, 577, 4113, 1974, 605, 2733, 864, 2891, 4139, 1771, 935, 315, 1956, 448, 169, 1825, 4019, 2153, 877, 106, 182, 265, 2580, 3231, 715, 1061, 1388, 4331, 604, 1877, 1731, 3224, 4304, 536, 2930, 3333, 297, 1846, 4126, 1082, 485, 583, 524, 2779, 2408, 3511, 1861, 2943, 1553, 3448, 467, 1481, 2675, 2679, 1859, 167, 3340, 727, 1402, 1408, 3942, 4123, 2229, 3760, 3145, 2948, 3009, 2478, 1680, 26, 654, 4106, 2544, 1535, 2555, 979, 3633, 2908, 301, 91, 2162, 1280, 1597, 1541, 369, 3904, 838, 3607, 599, 2307, 588, 520, 896, 2643, 728, 3244, 939, 1644, 2828, 105, 2172, 1539, 1517, 261, 1118, 3359, 900, 3717, 2060, 3682, 4235, 1428, 4302, 4221, 3641, 3409, 1108, 2752, 2261, 809, 580, 541, 1263, 1753, 1783, 690, 1417, 510, 2954, 2099, 1893, 1167, 1376, 4267, 3293, 4214, 4038, 161, 1966, 3195, 183, 1595, 3756, 561, 2853, 2533, 1697, 3865, 1648, 1938, 4023, 2950, 2559, 3801, 2129, 2691, 804, 162, 327, 3415, 3790, 3477, 2468, 2462, 310, 3805, 3167, 794, 2519, 3310, 2665, 1326, 486, 4006, 2325, 2841, 2274, 228, 2375, 1438, 2131, 3812, 2889, 2494, 3023, 2817, 4360, 1126, 1880, 1043, 4050, 855, 905, 3656, 661, 462, 1141, 4364, 1805, 2857, 3975, 1986, 452, 2506, 860, 2951, 576, 4166, 1373, 2767, 2160, 1844, 2070, 2685, 225, 3631, 1577, 4292, 4104, 1679, 1230, 2212, 719, 2356, 4180, 4345, 267, 805, 2031, 3544, 1794, 3560, 1324, 4303, 2126, 1245, 2380, 3007, 271, 3348, 364, 1054, 2089, 3899, 281, 2081, 1972, 2975, 3134, 3210, 3104, 787, 4402, 2803, 64, 1930, 606, 706, 382, 2175, 2363, 1026, 2376, 1900, 2966, 2852, 674, 4310, 3795, 791, 2935, 1386, 4359, 268, 2346, 2838, 3695, 658, 2399, 2176, 29, 4355, 1740, 3864, 630, 1420, 484, 3172, 1831, 589, 999, 801, 894, 3730, 3672, 3182, 4424, 1210, 1306, 3022, 2866, 4101, 1987, 426, 4118, 2256, 3620, 717, 2057, 2963, 1127, 296, 2683, 537, 3990, 3533, 698, 2144, 1788, 3969, 4199, 102, 1882, 2623, 2047, 2379, 2482, 3642, 2302, 4041, 1277, 3306, 4075, 2923, 104, 1725, 1069, 2439, 299, 39, 3647, 1556, 2489, 4352, 3372, 2077, 3584, 1294, 237, 723, 192, 3318, 3126, 200, 4049, 155, 504, 3277, 3613, 1412, 2257, 1236, 1468, 4052, 3872, 2166, 2815, 3949, 740, 2600, 3522, 4156, 4216, 1724, 109, 1492, 34, 3900, 2093, 3828, 1251, 1391, 1205, 790, 4103, 1088, 3223, 1297, 3971, 2409, 1085, 1037, 3588, 1103, 3410, 153, 4277, 793, 4247, 3475, 704, 3744, 2032, 887, 3358, 3059, 3431, 1174, 115, 2672, 242, 3345, 2700, 3845, 3627, 1186, 1399, 3841, 3389, 1744, 4132, 603, 1249, 2766, 2594, 1664, 2103, 312, 1906, 377, 1758, 2007, 66, 31, 3884, 4358, 2952, 4289, 1164, 1122, 3445, 1961, 207, 3140, 680, 1865, 898, 1456, 4053, 3443, 3714, 1480, 1603, 255, 1063, 2012, 1760, 685, 1423, 3675, 3370, 708, 1467, 796, 1633, 4220, 910, 329, 1323, 276, 4434, 492, 3111, 710, 3754, 3179, 3079, 1027, 1705, 4111, 1936, 68, 3602, 3088, 1006, 2086, 3585, 2740, 3862, 1784, 2802, 1111, 3269, 2836, 1405, 118, 1163, 24, 3144, 3087, 2689, 263, 3275, 2980, 1942, 386, 3538, 2336, 1912, 1543, 2207, 3970, 1829, 482, 3139, 619, 1591, 3407, 2894, 2323, 1547, 4066, 1447, 234, 1813, 4155, 1750, 2692, 12, 802, 2532, 2724, 370, 2106, 479, 767, 996, 837, 4368, 3869, 4386, 439, 2352, 1947, 3440, 4392, 2987, 2553, 358, 1695, 1059, 3355, 25, 2490, 390, 2024, 4175, 645, 3020, 288, 1189, 3356, 3296, 890, 2753, 2520, 548, 1200, 266, 1253, 4264, 501, 134, 1905, 514, 4295, 1611, 862, 532, 1053, 2475, 285, 1711, 4433, 511, 2890, 870, 2195, 3773, 3234, 2821, 2604, 730, 1798, 1298, 2757, 4400, 957, 2019, 3933, 568, 1849, 3344, 4002, 4070, 1284, 4389, 3678, 2586, 4330, 1997, 2135, 2370, 3999, 1990, 618, 395, 4444, 1039, 95, 1206, 4125, 180, 2358, 4350, 3423, 3213, 2137, 282, 48, 1244, 633, 3125, 3646, 4286, 1104, 2017, 741, 2945, 903, 4001, 293, 3546, 1203, 2218, 3879, 2464, 317, 1318, 3710, 3117, 1908, 1605, 2830, 4379, 475, 1398, 2566, 1564, 772, 4217, 827, 1835, 1498, 2101, 2504, 1658, 626, 208, 3161, 4190, 1173, 4176, 3827, 222, 2885, 4366, 1157, 4325, 466, 3235, 378, 179, 1451, 2276, 522, 538, 2563, 3350, 4224, 2764, 1632, 2068, 2050, 1922, 1463, 649, 227, 2042, 2360, 632, 1176, 3494, 1515, 1008, 3868, 3553, 2588, 2100, 2405, 318, 2926, 209, 3836, 1365, 4135, 1981, 4196, 2916, 1955, 3401, 3166, 4068, 530, 2237, 2386, 1093, 2248, 1653, 1202, 1387, 4272, 3852, 2191, 3138, 1099, 44, 2419, 2854, 1848, 552, 2228, 13, 863, 1239, 4259, 625, 1600, 2800, 4419, 1378, 138, 4097, 4219, 87, 4309, 4152, 487, 2084, 686, 2459, 3208, 488, 96, 1895, 1932, 406, 1710, 2714, 2709, 476, 1976, 1350, 1721, 4431, 3320, 2188, 2120, 1534, 2523, 926, 825, 861, 4429, 2152, 344, 2221, 2723, 4137, 2729, 3871, 2636, 4416, 2946, 834, 3220, 2295, 2956, 3823, 1274, 3230, 1415, 3768, 1316, 4204, 1077, 4087, 679, 3357, 3467, 2174, 1142, 3955, 3659, 3850, 1883, 3683, 1616, 2809, 198, 1821, 471, 1590, 930, 1097, 673, 4270, 4096, 3308, 2052, 335, 1374, 3232, 2550, 3951, 1527, 1514, 4184, 1820, 778, 594, 3741, 3759, 131, 1383, 2025, 3465, 2369, 3787, 4181, 907, 4237, 2022, 3824, 3493, 1215, 1214, 408, 2461, 4244, 932, 4187, 1050, 1112, 3153, 2920, 2647, 3034, 2856, 2092, 3193, 2130, 1267, 693, 1781, 2514, 2317, 1307, 1745, 3219, 2387, 3418, 1305, 3549, 2621, 3187, 3815, 4200, 2734, 2349, 816, 3018, 714, 3644, 2163, 1250, 3406, 669, 1902, 2301, 3254, 2562, 1970, 2168, 3846, 1283, 3027, 3530, 1816, 3630, 3434, 985, 84, 75, 211, 3653, 1959, 215, 1074, 873, 2079, 3387, 423, 906, 3737, 3954, 3932, 1610, 4213, 3965, 1407, 3380, 3925, 4040, 3323, 3590, 2108, 2236, 1628, 2784, 3256, 2512, 2286, 250, 2021, 314, 3566, 4349, 559, 1601, 3124, 653, 1325, 977, 1219, 585, 1439, 1466, 2721, 1078, 1812, 457, 3981, 2292, 937, 474, 3457, 4128, 385, 1941, 2536, 3373, 1687, 3557, 337, 305, 173, 3343, 2262, 2749, 3962, 2154, 3728, 3292, 4231, 2161, 1477, 2718, 3771, 429, 3353, 1243, 336, 2849, 3249, 2483, 3265, 3201, 1799, 4241, 146, 3567, 4017, 2877, 1916, 3038, 3128, 2319, 4115, 521, 321, 2246, 2605, 3578, 1545, 135, 2673, 3986, 223, 256, 987, 971, 1038, 1754, 3215, 196, 1010, 2961, 28, 2987, 1107, 1933, 3496, 3175, 1313, 874, 352, 754, 2134, 4091, 2331, 4011, 2148, 2862, 3217, 613, 2296, 2234, 3534, 2412, 3693, 4377, 2917, 666, 2602, 1052, 913, 3346, 1913, 3583, 4010, 1746, 1689, 62, 1637, 2396, 2587, 1641, 2525, 2624, 2073, 2622, 1441, 451, 879, 440, 221, 1, 1559, 4385, 854, 3888, 2524, 2996, 4205, 2087, 3105, 1927, 2030, 3329, 3721, 3399, 1596, 1342, 3634, 2611, 2933, 755, 1375, 747, 1300, 2508, 1032, 4015, 259, 3253, 17, 1743, 1081, 4035, 607, 3444, 3839, 212, 1570, 3198, 2027, 2676, 4404, 1140, 3964, 1121, 1613, 4228, 435, 3909, 2083, 2592, 3621, 4420, 3154, 2974, 3429, 3820, 954, 4013, 641, 1479, 4133, 1132, 865, 915, 4119, 1984, 273, 3394, 960, 4088, 2368, 3543, 2354, 4036, 1372, 2979, 3902, 2850, 938, 2542, 940, 339, 3326, 2710, 3352, 2098, 789, 1, 1523, 3225, 931, 2498, 1029, 4047, 3702, 1125, 4293, 4342, 1435, 2754, 2477, 3517, 444, 1056, 2364, 4301, 236, 3214, 3077, 1303, 909, 609, 2377, 4044, 2651, 4299, 1691, 2217, 1863, 3929, 1980, 3268, 3524, 515, 643, 675, 2351, 1159, 416, 2260, 2054, 3837, 3364, 695, 2616, 4083, 1301, 1240, 424, 720, 3435, 354, 579, 4154, 2238, 1530, 3937, 2345, 569, 1390, 1022, 3984, 368, 15, 2970, 2268, 3916, 1429, 2668, 3626, 2900, 2115, 2001, 60, 2214, 3740, 1864, 2479, 295, 2155, 1526, 4229, 77, 1179, 2631, 3233, 2111, 3043, 718, 542, 3816, 3049, 687, 3690, 2593, 3877, 2107, 1331, 3071, 3901, 2534, 2284, 4107, 3054, 1894, 2453, 631, 1576, 1095, 1801, 3004, 2382, 2993, 1897, 143, 857, 597, 503, 617, 3961, 2771, 140, 1777, 1149, 1341, 2887, 1242, 340, 2225, 3600, 4179, 3782, 1888, 1020, 1119, 924, 1461, 2263, 3183, 4361, 2910, 3226, 3658, 1482, 3261, 1654, 1925, 3012, 998, 3499, 1868, 1764, 1199, 4168, 557, 925, 2010, 844, 3778, 2842, 1361, 1334, 853, 1065, 4312, 962, 322, 2422, 3551, 2242, 3947, 4363, 3334, 2728, 2697, 2998, 4112, 2765, 3135, 4073, 3157, 4252, 2350, 2411, 3589, 1663, 4411, 1191, 3926, 4390, 833, 3476, 3985, 1418, 3360, 1204, 2231, 2617, 166, 3957, 1978, 2121, 3666, 615, 2882, 177, 3609, 1292, 101, 1772, 1659, 170, 2569, 3052, 1371, 1484, 2546, 1023, 4388, 760, 3055, 1886, 3774, 2394, 1727, 2844, 2549, 555, 3510, 4412, 1337, 436, 4033, 2167, 1536, 3704, 2402, 856, 1677, 2503, 634, 1356, 1184, 1837, 2748, 2799, 3222, 124, 2075, 663, 1993, 1403, 3983, 817, 4082, 2143, 3689, 933, 1625, 3960, 1060, 2034, 2868, 2789, 647, 1544, 3032, 3078, 3311, 4110, 2209, 2667, 3453, 1722, 3806, 376, 3586, 1013, 2931, 1957, 782, 195, 3870, 1066, 4381, 3652, 4077, 3948, 1510, 469, 4382, 2874, 1850, 1651, 3562, 897, 2273, 1414, 137, 2985, 1185, 1212, 743, 313, 1018, 3397, 4268, 3913, 1168, 803, 990, 2230, 2171, 1150, 746, 3956, 3194, 1113, 4395, 130, 4014, 21, 512, 4102, 495, 2285, 3749, 2911, 3173, 3489, 2695, 224, 671, 4371, 2205, 375, 2226, 2116, 2170, 1476, 1, 595, 47, 2863, 519];

  const directory = useRef(null);
  const myDirectory = useRef(null);
  const searchInput = useRef(null);

  const [searchId, setSearchId] = useState('');

  var previousTokenId;
  var nextTokenId;
  var isDeflatedSearch;
  var deflatedCurrent;
  var mineCurrent;
  var resultPrevious;
  var initialStartDeflated;
  var initialStartMine;
  var resultNext;
  var MaxToken = 4443;

  const genesis = {
    address: "0x7cb90567a118cd9f6ca326067a0813b289bdcb54",
    abi: [
      "function ownerOf(uint256 tokenId) external view returns (address owner)",
      "function balanceOf(address owner) public view override returns (uint256)",
    ]
  };

  const rota = {
    address: "0xDfB29501b42f63A947Ddc5249F185D6BcBE6986f",
    abi: [
      "function genesisMinted(uint16) public view returns (bool)"
    ]
  };

  useEffect(() => {
    totalDeflated()
    if (rotaToken[0] === null) {
      const rndInt = Math.floor(Math.random() * 4444) + 1
      console.log(rndInt);
      getNFTs(rndInt);
    }
    else {
      if (rotaToken !== undefined) {
        getNFTs(rotaToken[0])
        console.log(rotaToken[0])
      }
      else {
        const rndInt = Math.floor(Math.random() * 4444) + 1
        console.log(rndInt);
        getNFTs(rndInt);
      }
    }
  }, []);

  async function totalDeflated() {
    const RPC = "https://mainnet.infura.io/v3/54297732d5e249febec6978df023ee45";
    const provider = new ethers.providers.JsonRpcProvider(RPC);

    const genesisContract = new ethers.Contract(genesis.address, genesis.abi, provider);

    var balanceOf = await genesisContract.balanceOf("0x2760ac85236795eca08e474FdC3E7736c4DDeF2E")

    var balance = Number(balanceOf)
    var percentage = (Number(balanceOf) / 4444 * 100).toFixed(2)

    document.getElementById("deflatedApe").innerHTML = balance + "/4444 (" + percentage + "%)";
  }


  async function checkOwner(token) {

    const RPC = "https://mainnet.infura.io/v3/54297732d5e249febec6978df023ee45";
    const provider = new ethers.providers.JsonRpcProvider(RPC);

    const genesisContract = new ethers.Contract(genesis.address, genesis.abi, provider);

    var ownerOf = await genesisContract.ownerOf(token);


    if (ownerOf === "0x2760ac85236795eca08e474FdC3E7736c4DDeF2E") {
      document.getElementById("isActive").innerHTML = "DEFLATED"
      document.getElementById("isActive").style.color = "red"
    } else {
      document.getElementById("isActive").innerHTML = "ACTIVE"
      document.getElementById("isActive").style.color = "#e9ca7a"
    }
  }

  async function checkMutated(token) {

    const RPC = "https://mainnet.infura.io/v3/54297732d5e249febec6978df023ee45";
    const provider = new ethers.providers.JsonRpcProvider(RPC);

    const rotaContract = new ethers.Contract(rota.address, rota.abi, provider);

    var isMutated = await rotaContract.genesisMinted(token);

    console.log("test" + isMutated);

    if (isMutated) {
      document.getElementById("isMutated").innerHTML = "YES"
      document.getElementById("isMutated").style.color = "red"
    } else {
      document.getElementById("isMutated").innerHTML = "NO"
      document.getElementById("isMutated").style.color = "green"
    }
  }

  async function checkMutatedAsync(token) {

    const RPC = "https://mainnet.infura.io/v3/54297732d5e249febec6978df023ee45";
    const provider = new ethers.providers.JsonRpcProvider(RPC);

    const rotaContract = new ethers.Contract(rota.address, rota.abi, provider);

    var isMutated = await rotaContract.genesisMinted(token);

    return isMutated;
  }

  function delay(n) {
    return new Promise(function (resolve) {
      setTimeout(resolve, n * 500);
    });
  }

  async function getMyNFTs(params) {
    directory.current.style.display = "none";
    myDirectory.current.style.display = null;
    isDeflatedSearch = false;
    const options = {
      method: 'GET',
      url: `https://api.opensea.io/api/v2/chain/ethereum/account/${addr}/nfts`,
      params: {
        collection: "atsnft",
        limit: '200'
      },
      headers: {
        accept: 'application/json',
        'X-API-KEY': '2ccf0238d1ea4b88bc88c635f86e085f'
      }
    };

    axios
      .request(options)
      .then(function (response) {
        directory.current.style.display = "none";
        document.getElementById("showTraits").innerHTML = "";

        const result = response.data.nfts;

        console.log(result);

        for (var i = 0; i < result.length; i++) {

          myDirectory.current.innerHTML +=
            `<div class="col pb-3" style="height:400px">
            <div class="card border-0 shadow-sm">
              <div class="position-relative">
                <div class="position-absolute top-0 start-0 w-100 h-100">
                <a href="genesis?token=` + result[i].identifier + `"><img src="` + result[i].image_url + `" class="card-img-top" alt="Image" /></a>
                </div>
              </div>
              <div class="card-body pb-4">
                <div class="d-flex align-items-center justify-content-between mb-3">
                  <div style="text-decoration:none;z-index:99999" class="badge fs-sm text-nav bg-primary text-decoration-none">#` + result[i].identifier + `</div>
                </div>
              </div>
            </div>
          </div>`

        }



      })
      .catch(async function (error) {
        console.error(error);
        searchInput.current.value = ""
        searchInput.current.placeholder = "Invalid Token";
        await delay(3);
        searchInput.current.placeholder = "Enter Ape #";
      });
  }

  async function getDeflatedNFTs(params) {
    directory.current.style.display = null;
    myDirectory.current.style.display = "none";
    isDeflatedSearch = true;
    let owner = "0x2760ac85236795eca08e474FdC3E7736c4DDeF2E"
    const options = {
      method: 'GET',
      url: `https://api.opensea.io/api/v2/chain/ethereum/account/${owner}/nfts`,
      params: {
        collection: "atsnft",
        limit: "200"
      },
      headers: {
        accept: 'application/json',
        'X-API-KEY': '2ccf0238d1ea4b88bc88c635f86e085f'
      }
    };


    const nftPromise = axios.request(options)
    const dataPromise = nftPromise.then((response) => response)
      .catch(async function (error) {
        console.error(error);
        searchInput.current.value = ""
        searchInput.current.placeholder = "Invalid Token";
        await delay(3);
        searchInput.current.placeholder = "Enter Ape #";
      });
    const response = await dataPromise


    document.getElementById("showTraits").innerHTML = "";
    var getLength = response.data.nfts.length;
    if (deflatedCurrent === undefined) {
      deflatedCurrent = getLength - 1;
      resultPrevious = response.data.nfts[deflatedCurrent];
      initialStartDeflated = 1;
    } else {
      initialStartDeflated = 0;
      if (params === 1) {
        deflatedCurrent = deflatedCurrent + 1;
      } else {
        deflatedCurrent = deflatedCurrent - 1;
      }
      if (deflatedCurrent + 1 === getLength) {
        resultPrevious = response.data.nfts[deflatedCurrent];
        initialStartDeflated = 1;
      } else {
        resultPrevious = response.data.nfts[deflatedCurrent + 1];
      }
    }

    console.log(deflatedCurrent);

    var endDeflated;

    var result = response.data.nfts[deflatedCurrent];
    //Add Traits to the data for the "result" NFT
    console.log(result.identifier)
    console.log("TokenID above")
    const options2 = {
      method: 'GET',
      url: `https://api.opensea.io/api/v2/chain/ethereum/contract/0x7cb90567a118cd9f6ca326067a0813b289bdcb54/nfts/${result.identifier}`,
      params: {
      },
      headers: {
        accept: 'application/json',
        'X-API-KEY': '2ccf0238d1ea4b88bc88c635f86e085f'
      }
    };


    const nftPromise2 = axios.request(options2)
    const response2 = nftPromise2.then((response) => response)
      .catch(async function (error) {
        console.error(error);
        searchInput.current.value = ""
        searchInput.current.placeholder = "Invalid Token";
        await delay(3);
        searchInput.current.placeholder = "Enter Ape #";
      });
    console.log("response2")
    const res = await response2
    let traits = res.data.nft.traits
    console.log("result coming")
    result.traits = traits
    console.log(result)

    if (deflatedCurrent === 0) {
      resultNext = response.data.nfts[deflatedCurrent];
      endDeflated = 1;
    } else {
      resultNext = response.data.nfts[deflatedCurrent - 1];
    }

    var previousToken = Number(resultPrevious.identifier);
    previousTokenId = previousToken;
    var nextToken = Number(resultNext.identifier);
    nextTokenId = nextToken;

    checkOwner(result.identifier)
    checkMutated(result.identifier)

    document.getElementById("image").src = result.image_url;
    document.getElementById("name").innerHTML = "Ape #" + result.identifier;
    document.getElementById("rank").innerHTML = "Rank  #" + rarityOrder[result.identifier]
    document.getElementById("rankLink").href = "https://raritysniper.com/apes-together-strong/" + result.identifier;

    if (initialStartDeflated === 1) {
      document.getElementById("previous").style.display = "none";
    } else {
      document.getElementById("previous").style.display = null;
      document.getElementById("previous").innerHTML = `<i class="bx bx-left-arrow-alt fs-4 lh-1 me-n1"></i>` + `&nbsp;` + "Ape #" + previousToken;
    }

    if (endDeflated === 1) {
      document.getElementById("next").style.display = "none";
    } else {
      document.getElementById("next").style.display = null;
      document.getElementById("next").innerHTML = "Ape #" + nextTokenId + `&nbsp;` + `<i class="bx bx-right-arrow-alt fs-4 lh-1 me-n1"></i>`;
    }

    document.getElementById("opensea").href = "https://opensea.io/assets/ethereum/0x7cb90567a118cd9f6ca326067a0813b289bdcb54/" + result.identifier;
    document.getElementById("download").href = "https://s3.us-east-1.amazonaws.com/publicassets.atsnft.io/ats/images" + result.identifier + ".png";
    document.getElementById("opensea-image").href = "https://opensea.io/assets/ethereum/0x7cb90567a118cd9f6ca326067a0813b289bdcb54/" + result.identifier;

    var x = 0;
    var traitLength = result.traits.length;

    while (x < traitLength) {

      document.getElementById("showTraits").innerHTML += `<li class="list-group-item d-flex flex-column flex-sm-row align-items-center justify-content-between">
      <div class="d-flex align-items-center">
        <h4 class="fs-base fw-semibold text-nowrap ps-1 mb-0">` + result.traits[x].trait_type + `</h4>
      </div>
      <div class="fs-sm">` + result.traits[x].value + `</div>
    </li>`
      x++;
    }

    directory.current.style.display = null;



  }

  function buildTwitter(tokenId) {
    var url = "https://twitter.com/intent/tweet?text=";
    var records = "https://www.records.atsnft.io/genesis?token=" + tokenId
    var marketplace = "https://opensea.io/assets/ethereum/0x7cb90567a118cd9f6ca326067a0813b289bdcb54/" + tokenId

    var message = "Check out my genesis ATS #" + tokenId + " on the ApeRecords by @ATSNFT!\n\nDoes #ATSfollowATS?\n\n" + records + "\n\n" + marketplace;

    var text = escape(message)

    document.getElementById("twitter-share").href = url + text;
  }



  async function getNFTs(tokenId) {
    directory.current.style.display = null;
    myDirectory.current.style.display = "none";
    isDeflatedSearch = false;
    const options = {
      method: 'GET',
      url: `https://api.opensea.io/api/v2/chain/ethereum/contract/0x7cb90567a118cd9f6ca326067a0813b289bdcb54/nfts/${tokenId}`,
      params: {
      },
      headers: {
        accept: 'application/json',
        'X-API-KEY': '2ccf0238d1ea4b88bc88c635f86e085f'
      }
    };

    axios
      .request(options)
      .then(function (response) {
        document.getElementById("showTraits").innerHTML = "";

        var result = response.data.nft;
        console.log("Result Coming Next")
        console.log(result)
        var previousToken = Number(result.identifier) - 1;
        previousTokenId = previousToken;
        var nextToken = Number(result.identifier) + 1;
        nextTokenId = nextToken;

        checkOwner(tokenId);
        checkMutated(tokenId);
        buildTwitter(tokenId);

        document.getElementById("image").src = result.image_url;
        document.getElementById("name").innerHTML = "Ape #" + result.identifier;
        document.getElementById("rank").innerHTML = "Rank  #" + rarityOrder[result.identifier]
        document.getElementById("rankLink").href = "https://raritysniper.com/apes-together-strong/" + result.identifier;
        if (previousToken < 0) {
          document.getElementById("previous").style.display = "none";
        } else {
          document.getElementById("previous").style.display = null;
          document.getElementById("previous").innerHTML = `<i class= "bx bx-left-arrow-alt fs-4 lh-1 me-n1"></i> ` + ` &nbsp; ` + "Ape #" + previousToken;
        }

        if (nextTokenId > MaxToken) {
          document.getElementById("next").style.display = "none";
        } else {
          document.getElementById("next").style.display = null;
          document.getElementById("next").innerHTML = "Ape #" + nextTokenId + `&nbsp; ` + ` <i class="bx bx-right-arrow-alt fs-4 lh-1 me-n1"></i> `;
        }


        document.getElementById("opensea").href = "https://opensea.io/assets/ethereum/0x7cb90567a118cd9f6ca326067a0813b289bdcb54/" + result.identifier;
        document.getElementById("download").href = "https://s3.us-east-1.amazonaws.com/publicassets.atsnft.io/ats/images/" + result.identifier + ".png";
        document.getElementById("opensea-image").href = "https://opensea.io/assets/ethereum/0x7cb90567a118cd9f6ca326067a0813b289bdcb54/" + result.identifier;

        var x = 0;
        var traitLength = result.traits.length;

        while (x < traitLength) {

          document.getElementById("showTraits").innerHTML += `<li class="list-group-item d-flex flex-column flex-sm-row align-items-center justify-content-between">
              <div class="d-flex align-items-center">
                <h4 class="fs-base fw-semibold text-nowrap ps-1 mb-0">` + result.traits[x].trait_type + `</h4>
              </div>
              <div class="fs-sm">` + result.traits[x].value + `</div>
            </li> `
          x++;
        }

        directory.current.style.display = null;


      })
      .catch(async function (error) {
        console.error(error);
        searchInput.current.value = ""
        searchInput.current.placeholder = "Invalid Token";
        await delay(3);
        searchInput.current.placeholder = "Enter Ape #";
      });
  }

  function runModel(e) {
    console.log(searchId);
    e.preventDefault();
    getNFTs(searchId);
  }

  function previous(e) {
    e.preventDefault();
    if (!isDeflatedSearch) {
      getNFTs(previousTokenId);
    } else {

      getDeflatedNFTs(1);

    }
    searchInput.current.value = ""
  }

  function next(e) {
    e.preventDefault();
    if (!isDeflatedSearch) {
      getNFTs(nextTokenId);
    } else {
      getDeflatedNFTs();

    }
    searchInput.current.value = ""
  }


  function random(e) {
    e.preventDefault();
    const rndInt = Math.floor(Math.random() * 4444) + 1
    getNFTs(rndInt);
  }

  function deflated(e) {
    e.preventDefault();
    getDeflatedNFTs();
  }

  function mine(e) {
    e.preventDefault();
    getMyNFTs();
  }



  return (
    <div className="page-wrapper">
      <header className="header navbar navbar-expand-lg bg-secondary shadow-sm shadow-dark-mode-none">
        <div className="container px-3">
          <a href="https://atsnft.io/" className="navbar-brand pe-3">
            <img src="ape-white.png" width={47} alt="Logo" />
          </a>
          <div id="navbarNav" className="offcanvas offcanvas-end">
            <div className="offcanvas-header border-bottom">
              <h5 className="offcanvas-title">Menu</h5>
              <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close" />
            </div>
            <div className="offcanvas-body">
              <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                <li className="nav-item">
                  <a href="https://records.atsnft.io/" className="nav-link text-nowrap active" style={{ color: "#e9ca7a" }}>Records</a>
                </li>
                <li className="nav-item">
                  <a href="https://marketplace.atsnft.io/" target="_blank" className="nav-link text-nowrap">Marketplace</a>
                </li>
                <li className="nav-item">
                  <a
                    href="https://war.atsnft.io/"
                    className="nav-link text-nowrap"
                  >
                    War
                  </a>
                </li>
                <li className="nav-item">
                  <a href="https://records.atsnft.io/tickets" className="nav-link text-nowrap">Tickets</a>
                </li>
                <a href="https://twitter.com/ATSNFT" target="_blank" className="btn btn-icon btn-secondary btn-twitter d-none rounded-circle mx-1 d-lg-inline-flex"><i className="bx bxl-twitter"></i></a>
                <a href="https://discord.com/invite/ATSNFT" target="_blank" className="btn btn-icon btn-secondary btn-discord d-none rounded-circle mx-1 d-lg-inline-flex"><i className="bx bxl-discord"></i></a>
              </ul>
            </div>
            <div className="offcanvas-header border-top">
              <ConnectWallet
                btnTitle="Log In"
                theme="dark"
              />
            </div>
          </div>
          <button type="button" className="navbar-toggler" data-bs-toggle="offcanvas" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon" />
          </button>
          <ConnectWallet
            btnTitle="Log In"
            theme="dark"
          />
        </div>
      </header>

      <section className="container d-md-flex align-items-center justify-content-between pb-3 py-5">

        <nav className="container">

          <ul className="nav nav-tabs-alt flex-nowrap border-0">
            <li className="nav-item">
              <a href="/genesis" className="nav-link text-nowrap active" style={{ color: "#e9ca7a" }}><img style={{ maxHeight: "30px", marginRight: "10px" }} src="ape-white.png"></img>Genesis</a>
            </li>
            <li className="nav-item">
              <a href="/rota" className="nav-link text-nowrap"><img style={{ maxHeight: "30px", marginRight: "10px" }} src="ape.png"></img>ROTA</a>
            </li>
          </ul>

          <form className="input-group mb-4" style={{ maxWidth: '100%' }} onSubmit={e => { runModel(e) }} >
            <input ref={searchInput} value={searchId} onChange={e => setSearchId(e.target.value)} type="number" placeholder="Enter Ape #" className="form-control rounded" />
            <button type="button" className="btn btn-primary  btn-sm fs-sm rounded d-lg-inline-flex" style={{ marginRight: "20px" }} onClick={e => runModel(e)} >Search</button>
          </form>

          <div className="d-flex justify-content-left pt-4 py-5" >
            <button type="button" onClick={e => random(e)} className="btn btn-success bg-faded-primary btn-sm fs-sm rounded d-lg-inline-flex" style={{ marginRight: "10px" }} >Random</button>
            <button type="button" onClick={e => deflated(e)} className="btn btn-danger bg-faded-primary btn-sm fs-sm rounded d-lg-inline-flex" style={{ marginRight: "10px" }} >Deflated</button>
            <button id="myapes" type="button" onClick={e => mine(e)} className="btn btn-info bg-faded-primary btn-sm fs-sm rounded d-lg-inline-flex disabled-button" >My Genesis</button>
          </div>

        </nav>

      </section>

      <section ref={directory} className="container pb-5 mb-2 mb-md-4 mb-lg-5" style={{ display: "none" }}>
        <div className="row justify-content-center ">
          <div className="col-lg-10 col-md-11">
            <div className="row row-cols-1 row-cols-md-2 g-4">
              <div className="col">
                <div className="card border-0 shadow-sm ">
                  <div className="card-body d-flex align-items-center">
                    <div className="rounded-3 flex-shrink-0" style={{ objectFit: 'cover', width: '100%' }}>
                      <div className="d-flex justify-content-center py-3">
                        <a className="btn mx-1">
                          <span id="name"></span>
                        </a>
                        <a href="#" id="rankLink" target="_blank" className="btn mx-1">
                          <span id="rank" style={{ color: "#e9ca7a" }}></span>
                        </a>
                      </div>
                      <div className="d-flex justify-content-center py-3">
                        <a id="opensea" target="_blank" className="btn btn-icon btn-secondary btn-facebook mx-1">
                          <i className="bx"><img className="align-items-right" src="opensea.png" width={30} alt="Logo" /></i>
                        </a>
                        <a id="twitter-share" target="_blank" className="btn btn-icon btn-secondary btn-twitter mx-1">
                          <i className="bx bxl-twitter"></i>
                        </a>

                        <a id="download" target="_blank" className="btn btn-icon btn-secondary btn-facebook mx-1">
                          <i className="bx"><img className="align-items-right" src="download.png" width={20} alt="Logo" /></i>
                        </a>
                      </div>
                      <a id="opensea-image" target="_blank">
                        <img className="rounded-3 py-3" style={{ borderRadius: "10px" }} id="image" />
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col">
                <div className="card h-100 border-0 shadow-sm">
                  <div className="d-flex justify-content-center pt-4 mt-lg-3">
                    <a onClick={e => previous(e)} type="button" className="btn btn-secondary  mx-1" id="previous"></a>
                    <a onClick={e => next(e)} type="button" className="btn btn-secondary mx-1" id="next"><i className="bx bx-right-arrow-alt fs-4 lh-1 ms-2 me-n1"></i></a>
                  </div>


                  <div className="card-body align-items-center">
                    <ul className="list-group">
                      <li className="list-group-item d-flex flex-column flex-sm-row align-items-center justify-content-between">
                        <div className="d-flex align-items-center">
                          <h4 className="fs-base fw-semibold text-nowrap ps-1 mb-0">Status</h4>
                        </div>
                        <div className="fs-sm" id="isActive"></div>

                      </li>

                      <li className="list-group-item d-flex flex-column flex-sm-row align-items-center justify-content-between">
                        <div className="d-flex align-items-center">
                          <h4 className="fs-base fw-semibold text-nowrap ps-1 mb-0">Mutated</h4>
                        </div>
                        <div className="fs-sm" style={{ fontWeight: "800" }} id="isMutated"></div>

                      </li>

                      <li className="list-group-item d-flex flex-column flex-sm-row align-items-center justify-content-between">
                        <div className="d-flex align-items-center">
                          <h4 className="fs-base fw-semibold text-nowrap ps-1 mb-0">Total Deflated</h4>
                        </div>
                        <div className="fs-sm" id="deflatedApe"></div>



                      </li><br />
                    </ul>
                    <ul id="showTraits" className="list-group"></ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </section>
      <div className="container">
        <section ref={myDirectory} className="row row-cols-lg-4 row-cols-sm-2 row-cols-1 gy-md-4 gy-2">

        </section>
      </div>


    </div>

  );
}

export default App;